<template>
  <div id="app">
    <!-- Google Translate Widget -->
    <router-view class="flex-grow"></router-view>
    <!-- Storefront chrome (footer + mobile bottom nav) — both follow the
         same gate so CRM pages (admin / super-admin / vendor / livreur)
         never inherit client-side chrome, even if a route author forgot
         to set `hideFooter: true`. -->
    <FootBar v-if="showStorefrontChrome" />
    <BottomNav v-if="showBottomNav" />
    <div v-if="showBottomNav" class="md:hidden h-14" aria-hidden="true" />
  </div>
</template>

<script>
import FootBar from '@/components/footBar.vue'
import BottomNav from '@/components/storefront/BottomNav.vue'

export default {
  name: 'App',
  components : {FootBar, BottomNav} ,
  computed: {
    /**
     * Storefront chrome (footer) gate — hides on any CRM-flagged route.
     * Token state is irrelevant here: a logged-out visitor browsing the
     * homepage should still see the footer, but the same visitor on
     * /admin/dashboard should not.
     */
    showStorefrontChrome() {
      const matched = this.$route.matched || [];
      const anyMeta = (key) => matched.some((r) => r.meta && r.meta[key]);
      if (anyMeta('hideFooter')) return false;
      if (anyMeta('isAdmin') || anyMeta('isSuperAdmin') || anyMeta('isVendeur') || anyMeta('isLivreur')) return false;
      return true;
    },

    /**
     * The bottom nav is a client-only chrome. It must be hidden whenever
     * we're inside any CRM context — admin, super-admin, vendor or livreur
     * — regardless of whether a route author remembered to set
     * `hideFooter: true`.
     *
     * Three independent gates, ANY one hides the nav:
     *  1. The route has `hideFooter` meta (admin/vendor/livreur shells).
     *  2. The route declares any non-client role flag in its meta chain
     *     (isAdmin / isSuperAdmin / isVendeur / isLivreur).
     *  3. A non-client token exists in store or localStorage — meaning the
     *     visitor is logged in as a CRM role on this device.
     */
    showBottomNav() {
      const matched = this.$route.matched || [];
      const anyMeta = (key) => matched.some((r) => r.meta && r.meta[key]);

      if (anyMeta('hideFooter')) return false;
      if (anyMeta('isAdmin') || anyMeta('isSuperAdmin') || anyMeta('isVendeur') || anyMeta('isLivreur')) return false;

      const ls = (k) => {
        try { return localStorage.getItem(k); } catch (e) { return null; }
      };
      const hasVendeur  = !!(this.$store.state.vendeurToken  || ls('vendeurToken')  || this.$store.state.vendeurId  || ls('vendeurId'));
      const hasLivreur  = !!(this.$store.state.livreurToken  || ls('livreurToken')  || this.$store.state.livreurId  || ls('livreurId'));
      const hasAdmin    = !!(this.$store.state.adminToken    || ls('adminToken'));
      const hasSuper    = !!(this.$store.state.superAdminToken || ls('superAdminToken'));

      if (hasVendeur || hasLivreur || hasAdmin || hasSuper) return false;
      return true;
    },
  },
};
</script>

<style>
.translate-widget {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
}
</style>
